<!-- src/views/Dashboard.vue -->
<template>
  <section class="content">
    <div class="container-fluid">

      <div class="card shadow rounded">
        <div class="card-header bg-primary text-white">
          <h3 class="mb-0">Data Warga De Park</h3>
        </div>

        <div class="card-body">
          <h5 class="mb-4 text-secondary">Nama: {{ nama }}</h5>

          <form @submit.prevent="updateProfile">
            <!-- Informasi Umum -->
            <div class="row">
              <div class="col-md-6 mb-3">
                <label for="nama" class="form-label">Nama</label>
                <input v-model="form.nama" type="text" class="form-control" id="nama" required />
              </div>

              <div class="col-md-6 mb-3">
                <label for="email" class="form-label">Email</label>
                <input v-model="form.email" type="email" class="form-control" id="email" required readonly />
              </div>

              <div class="col-md-6 mb-3">
                <label for="no_hp" class="form-label">No. Handphone</label>
                <input
                  v-model="form.no_hp"
                  @input="form.no_hp = form.no_hp.replace(/\D/g, '')"
                  type="text"
                  class="form-control"
                  id="no_hp"
                  required
                />
              </div>

              <div class="col-md-6 mb-3">
                <label for="cluster" class="form-label">Cluster</label>
                <select v-model="form.cluster" class="form-control" id="cluster" required>
                  <option disabled value="">-- Pilih Cluster --</option>
                  <option value="De Cajuputi">De Cajuputi</option>
                  <option value="De Naara">De Naara</option>
                  <option value="De Maja">De Maja</option>
                  <option value="De Frangipani">De Frangipani</option>
                  <option value="De Brassia">De Brassia</option>
                  <option value="De Heliconia">De Heliconia</option>
                </select>
              </div>
              
              <div class="col-md-6 mb-3">
                <label for="blok" class="form-label">Blok</label>
                <input
                  v-model="form.blok"
                  @input="form.blok = form.blok.toUpperCase()"
                  type="text"
                  class="form-control"
                  id="blok"
                  required
                />
              </div>

              <div class="col-md-6 mb-3">
                <label for="no_rumah" class="form-label">No. Rumah</label>
                <input
                  v-model="form.no_rumah"
                  @input="form.no_rumah = form.no_rumah.replace(/\D/g, '')"
                  type="text"
                  class="form-control"
                  id="no_rumah"
                  required
                />
              </div>

                            <!-- ✅ Tambahan RT -->
              <div class="col-md-6 mb-3">
                <label for="rt" class="form-label">RT</label>
                <input
                  v-model="form.rt"
                  @input="form.rt = form.rt.replace(/[^0-9]/g, '').slice(0,3)"
                  type="text"
                  class="form-control"
                  id="rt"
                  required
                  maxlength="3"
                  pattern="^[0-9]{1,3}$"
                  placeholder="contoh: 001"
                  title="Masukkan RT berupa angka 1–3 digit (boleh dengan 0 di depan, contoh: 001)"
                />
              </div>

              <!-- ✅ Tambahan RW -->
              <div class="col-md-6 mb-3">
                <label for="rw" class="form-label">RW</label>
                <input
                  v-model="form.rw"
                  @input="form.rw = form.rw.replace(/[^0-9]/g, '').slice(0,3)"
                  type="text"
                  class="form-control"
                  id="rw"
                  required
                  maxlength="3"
                  pattern="^[0-9]{1,3}$"
                  placeholder="contoh: 002"
                  title="Masukkan RW berupa angka 1–3 digit (boleh dengan 0 di depan, contoh: 002)"
                />
              </div>

            </div>

            <!-- Kendaraan -->
            <hr />
            <h5 class="mt-3">Daftar Kendaraan</h5>

            <div
              v-for="(item, index) in kendaraanList"
              :key="index"
              class="mb-3 row align-items-end"
            >
              <div class="col-md-4">
                <label class="form-label">Tipe</label>
                <select v-model="item.type_kendaraan" class="form-select" required>
                  <option disabled value="">-- Pilih Type Kendaraan --</option>
                  <option value="Mobil">Mobil</option>
                  <option value="Motor">Motor</option>
                </select>
              </div>

              <div class="col-md-4">
                <label class="form-label">Plat Nomor</label>
                <input
                  v-model="item.plat_nomor"
                  @input="item.plat_nomor = item.plat_nomor.toUpperCase().replace(/[^A-Z0-9]/g, '')"
                  type="text"
                  class="form-control"
                  placeholder="Plat Nomor"
                  required
                />
              </div>

              <div class="col-md-2">
                <button
                  class="btn btn-outline-danger"
                  @click="hapusBaris(index)"
                  v-if="kendaraanList.length > 1"
                >
                  Hapus
                </button>
              </div>
            </div>

            <button class="btn btn-outline-success mb-4" @click="tambahBaris">
              + Tambah Baris
            </button>

            <!-- Tombol Submit & Reset -->
            <div class="text-end">
              <button type="submit" class="btn btn-outline-primary me-2 mb-4">Submit</button>
              <button type="reset" class="btn btn-outline-danger mb-4" @click.prevent="confirmReset">Reset</button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </section>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import axios from 'axios'
import { useRouter } from 'vue-router'
import alert from '@/utils/alert'
import Swal from 'sweetalert2'

const router = useRouter()

const kendaraanList = ref([{ type_kendaraan: '', plat_nomor: '' }])

function tambahBaris() {
  kendaraanList.value.push({ type_kendaraan: '', plat_nomor: '' })
}

function hapusBaris(index) {
  kendaraanList.value.splice(index, 1)
}

const form = ref({
  nama: '',
  email: '',
  no_hp: '',
  cluster: '',
  blok: '',
  no_rumah: '',
  rt: '',
  rw: '',
  kendaraan: [],
})

const nama = ref('')
const loading = ref(true)

onMounted(async () => {
  const token = localStorage.getItem('token')
  const storedNama = localStorage.getItem('nama') || ''
  const storedEmail = localStorage.getItem('username') || ''
  if (storedNama) {
    nama.value = storedNama
  }
  if (!token) {
    alert.error('Unauthorized!')
    router.push('/')
    return
  }

  const ProfileData = {
    email: storedEmail,
    token: token,
  }

  try {
    const response = await axios.post('https://metatekapps.metateknologi.com/api-vms-get-profile.php', {
      params: ProfileData,
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (response.data.status === 200) {
      form.value = response.data.data
      if (Array.isArray(form.value.kendaraan) && form.value.kendaraan.length > 0) {
        kendaraanList.value = form.value.kendaraan
      } else {
        kendaraanList.value = [{ type_kendaraan: '', plat_nomor: '' }]
      }
    } else {
      alert(response.data.message || 'Gagal mengambil data profil.')
    }

  } catch (err) {
    console.error(err)
    alert.error('Gagal mengambil data!')
  } finally {
    loading.value = false
  }
})

async function updateProfile() {
  const token = localStorage.getItem('token')

  const updatedData = {
    nama: form.value.nama,
    email: form.value.email,
    no_hp: form.value.no_hp,
    cluster: form.value.cluster,
    blok: form.value.blok,
    no_rumah: form.value.no_rumah,
    rt: form.value.rt,
    rw: form.value.rw,
    kendaraan: kendaraanList.value,
    token: token,
  }

  try {
    const response = await axios.put('https://metatekapps.metateknologi.com/api-vms-update-profile.php', updatedData, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })

    if (response.data.status === 200) {
      localStorage.setItem('nama', form.value.nama)
      nama.value = form.value.nama
      alert.success('Profil berhasil diperbarui!')
      router.push('/profile')
    } else {
      alert(response.data.message || 'Gagal memperbarui profil.')
    }

  } catch (error) {
    console.error('Update failed:', error)
    alert('Terjadi kesalahan saat memperbarui profil.')
  }
}

// ✅ Reset form tanpa hapus nama & email
function confirmReset() {
  Swal.fire({
    title: 'Yakin mau reset?',
    text: 'Semua perubahan pada form akan dihapus (kecuali nama & email).',
    icon: 'warning',
    showCancelButton: true,
    confirmButtonColor: '#3085d6',
    cancelButtonColor: '#d33',
    confirmButtonText: 'Ya, reset!',
    cancelButtonText: 'Batal',
  }).then((result) => {
    if (result.isConfirmed) {
      const keepNama = form.value.nama
      const keepEmail = form.value.email

      form.value = {
        nama: keepNama,
        email: keepEmail,
        no_hp: '',
        cluster: '',
        blok: '',
        no_rumah: '',
        rt: '',
        rw: '',
        kendaraan: [],
      }

      kendaraanList.value = [{ type_kendaraan: '', plat_nomor: '' }]

      Swal.fire('Direset!', 'Form berhasil direset (nama & email tetap).', 'success')
    }
  })
}
</script>
